import React from "react";
import { FaExternalLinkAlt, FaGithub } from "react-icons/fa";

const storeBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  background: '#23272b',
  color: '#ff8c00',
  border: 'none',
  borderRadius: '6px',
  padding: '6px 14px',
  fontWeight: 400,
  fontSize: 16,
  marginRight: 10,
  textDecoration: 'none',
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
  transition: 'background 0.2s, color 0.2s',
};

const ProjectCard = ({heading, subHeading, details, link, github}) => {
    return (
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0 text-primary">{heading}</h3>
          <div class="subheading mb-3">{subHeading}</div>
          <div>{details}</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 16 }}>
            {link && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                style={storeBtnStyle}
              >
                <FaExternalLinkAlt size={18} style={{ verticalAlign: 'middle' }} /> Visit Site
              </a>
            )}
            {github && (
              <a
                href={github}
                target="_blank"
                rel="noopener noreferrer"
                style={storeBtnStyle}
              >
                <FaGithub size={18} style={{ verticalAlign: 'middle' }} /> GitHub
              </a>
            )}
          </div>
        </div>
      </div>
    );
}

export default ProjectCard;